import { Reference, useMutation } from '@apollo/client';

import {
  GetJourneyWithPlanQuery,
  WorksheetCreateDocument,
  WorksheetCreateMutation,
  WorksheetCreateMutationVariables,
  WorksheetFragmentDoc
} from '@typing/Generated';

const useCreateWorksheet = (journey: GetJourneyWithPlanQuery['journey'] | undefined) => {
  const [mutation] = useMutation<WorksheetCreateMutation, WorksheetCreateMutationVariables>(WorksheetCreateDocument, {
    update: (store, { data }) => {
      if (data?.worksheetCreate?.worksheet) {
        store.modify({
          fields: {
            worksheets(cachedWorksheetRefs: readonly Reference[]) {
              const newWorksheetRef = store.writeFragment({
                data: data.worksheetCreate?.worksheet,
                fragment: WorksheetFragmentDoc,
                fragmentName: 'Worksheet'
              });
              if (newWorksheetRef && data.worksheetCreate?.worksheet) {
                return [...cachedWorksheetRefs, newWorksheetRef];
              }
              return [...cachedWorksheetRefs];
            }
          },
          id: store.identify({ __typename: 'Journey', id: journey?.id })
        });

        const goal = data.worksheetCreate.worksheet.goal;

        if (goal) {
          store.modify({
            fields: {
              worksheets(cachedWorksheetRefs: readonly Reference[]) {
                const newWorksheetRef = store.writeFragment({
                  data: data.worksheetCreate?.worksheet,
                  fragment: WorksheetFragmentDoc,
                  fragmentName: 'Worksheet'
                });

                if (newWorksheetRef) {
                  return [...cachedWorksheetRefs, newWorksheetRef];
                }
                return [...cachedWorksheetRefs];
              }
            },
            id: store.identify({ ...goal })
          });
        }
      }
    }
  });
  return mutation;
};

export default useCreateWorksheet;
